import { render, staticRenderFns } from "./TrainingApproval.vue?vue&type=template&id=04637a47&"
import script from "./TrainingApproval.vue?vue&type=script&lang=js&"
export * from "./TrainingApproval.vue?vue&type=script&lang=js&"
import style0 from "./TrainingApproval.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports